import {get} from 'lodash-es'
import {type ValidationRule} from '..'

///////////////////////////////////////////////////////////////////////////////

export const colorCode: ValidationRule = ({field, data}) => {
  const value = get<string | undefined>(data, field, '') ?? ''

  if (!value) {
    return
  }

  // Allow hashtag, numbers and letters
  const regex = /^#?(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/

  if (!regex.test(value)) {
    return {message: 'color_code.not_valid'}
  }
}
